import { AlertTriangle } from "lucide-react";

interface AlertProps {
  variant: "error";
  message: string;
}

export function Alert({ message }: AlertProps) {
  return (
    <div className="flex items-center gap-2 rounded-lg border border-[#FEE2E2] bg-[#FEF2F2] px-4 py-3">
      <AlertTriangle
        className="size-3.5 shrink-0 text-[#DC2626]"
        strokeWidth={2}
      />
      <span className="text-[13px] font-medium text-[#DC2626]">{message}</span>
    </div>
  );
}
